export const getManifestBadgeColor = status => {
  switch (status) {
    case 'created':
      return 'secondary';

    case 'closed':
    case 'discarded':
      return 'danger';

    default:
      return 'secondary';
  }
};
